// A boat's order file (Info / Files › New order file): the yard's order template (TEMPLATE 27) as rows,
// each tied to its Order Sheet column, so the order form, the Order Sheet and the workbook handed to the
// assembly crews all read and write the same cells. Rows are in the template's order, with its English and
// Greek wording; a band (SET UP, EXTRAS) and a section (LAYOUT, COLORS, …) are headings, a text row takes
// words (a colour, the engines, an additional request) and an option row is ticked ("+") or noted.
export const ORDER_FILE_TEMPLATE = [
    { kind: 'band', key: 'D', en: 'SET UP:', gr: '' },
    { kind: 'section', key: 'E', en: 'LAYOUT:', gr: 'ΔΙΑΡΥΘΜΗΣΗ:' },
    { kind: 'text', key: 'F', en: 'BOW:', gr: 'ΠΛΩΡΗ' },
    { kind: 'text', key: 'G', en: 'STERN:', gr: 'ΠΡΥΜΝΗ' },
    { kind: 'text', key: 'H', en: 'FIRST ROW OF SEATS', gr: 'ΠΡΩΤΗ ΣΕΙΡΑ ΚΑΘΙΣΜΑΤΩΝ' },
    { kind: 'text', key: 'I', en: 'SECOND ROW OF SEATS', gr: 'ΔΕΥΤΕΡΗ ΣΕΙΡΑ ΚΑΘΙΣΜΑΤΩΝ' },
    { kind: 'section', key: 'J', en: 'COLORS:', gr: 'ΧΡΩΜΑΤΑ:' },
    { kind: 'text', key: 'K', en: 'UPHOLSTERY COLOR:', gr: 'ΤΑΠΕΤΣΑΡΙΕΣ' },
    { kind: 'text', key: 'L', en: 'HULL COLOR:', gr: 'ΓΑΣΤΡΑ' },
    { kind: 'text', key: 'M', en: 'DECK COLOR:', gr: 'ΝΤΕΚ' },
    { kind: 'text', key: 'N', en: 'TUBES:', gr: 'ΜΠΑΛΟΝΙ' },
    { kind: 'text', key: 'O', en: 'PROTECTION FENDER:', gr: 'ΠΕΡΙΜΕΤΡΙΚΟ' },
    { kind: 'text', key: 'P', en: 'FLOORING', gr: 'ΠΑΤΩΜΑ' },
    { kind: 'section', key: 'Q', en: 'ENGINES:', gr: 'ΜΗΧΑΝΕΣ:' },
    { kind: 'text', key: 'R', en: 'PRE-RIGGING', gr: 'PRE-RIGGING' },
    { kind: 'text', key: 'S', en: 'NUMBER OF', gr: 'ΑΡ. ΜΗΧΑΝΩΝ' },
    { kind: 'text', key: 'T', en: 'MERCURY', gr: 'MERCURY' },
    { kind: 'text', key: 'U', en: 'YAMAHA', gr: 'YAMAHA' },
    { kind: 'text', key: 'V', en: 'VOLVO', gr: 'VOLVO' },
    { kind: 'text', key: 'W', en: 'YANMAR', gr: 'YANMAR' },
    { kind: 'section', key: 'X', en: 'ENGINE PERIPHERALS:', gr: 'ΠΕΡΙΦΕΡΙΑΚΑ ΜΗΧΑΝΩΝ:' },
    { kind: 'option', key: 'Y', en: "MERCURY VESSEL VIEW 7''", gr: "MERCURY ΟΘΟΝΗ 7''" },
    { kind: 'option', key: 'Z', en: "VOLVO SCREEN 9''", gr: "VOLVO ΟΘΟΝΗ 9''" },
    { kind: 'option', key: 'AA', en: "YAMAHA SCREEN 5''", gr: "YAMAHA ΟΘΟΝΗ 5''" },
    { kind: 'option', key: 'AB', en: "YAMAHA SCREEN 7''", gr: "YAMAHA ΟΘΟΝΗ 7''" },
    { kind: 'option', key: 'AC', en: 'HYDRAULIC STEERING', gr: 'ΥΔΡΑΥΛΙΚΟ ΤΙΜΟΝΙ' },
    { kind: 'option', key: 'AD', en: 'ELECTRIC STEERING', gr: 'ΗΛΕΚΤΡΙΚΟ ΤΙΜΟΝΙ' },
    { kind: 'option', key: 'AE', en: 'JOYSTICK', gr: 'JOYSTICK' },
    { kind: 'option', key: 'AF', en: 'RAYMARINE AUTOPILOT', gr: 'ΑΥΤΟΜΑΤΟΣ ΠΙΛΟΤΟΣ RAYMARINE' },
    { kind: 'band', key: 'AG', en: 'EXTRAS:', gr: 'ΕΞΤΡΑ:' },
    { kind: 'section', key: 'AH', en: 'INSTRUMENTS:', gr: 'ΟΡΓΑΝΑ:' },
    { kind: 'option', key: 'AI', en: 'RAYMARINE', gr: 'RAYMARINE' },
    { kind: 'option', key: 'AJ', en: 'GARMIN', gr: 'GARMIN' },
    { kind: 'option', key: 'AK', en: '110V', gr: '110V' },
    { kind: 'option', key: 'AL', en: '220V', gr: '220V' },
    { kind: 'option', key: 'AM', en: "16'' SCREEN", gr: "16'' ΟΘΟΝΗ" },
    { kind: 'option', key: 'AN', en: "12'' SCREEN", gr: "12'' ΟΘΟΝΗ" },
    { kind: 'option', key: 'AO', en: "9'' SCREEN", gr: "9'' ΟΘΟΝΗ" },
    { kind: 'option', key: 'AP', en: 'SECOND SCREEN SAME SIZE', gr: 'ΔΕΥΤΕΡΗ ΟΘΟΝΗ ΙΔΙΟΥ ΜΕΓΕΘΟΥΣ' },
    { kind: 'option', key: 'AQ', en: 'THIRD SCREEN SAME SIZE', gr: 'ΤΡΙΤΗ ΟΘΟΝΗ ΙΔΙΟΥ ΜΕΓΕΘΟΥΣ' },
    { kind: 'option', key: 'AR', en: 'VHF', gr: 'VHF' },
    { kind: 'option', key: 'AS', en: 'GMDSS', gr: 'GMDSS' },
    { kind: 'option', key: 'AT', en: 'AIS-B', gr: 'AIS-B' },
    { kind: 'option', key: 'AU', en: 'FUSION 6 SPEAKERS, 2 AMPLIFIERS, 1 SUBWOOFER', gr: 'ΗΧΟΣΥΣΤΗΜΑ ΜΕ 6 ΗΧΕΙΑ, 2 ΕΝΙΣΧΥΤΕΣ, 1 SUB' },
    { kind: 'option', key: 'AV', en: 'FUSION 4 SPEAKERS', gr: 'ΗΧΟΣΥΣΤΗΜΑ ΜΕ 4 ΗΧΕΙΑ' },
    { kind: 'option', key: 'AW', en: 'THERMAL CAMERA', gr: 'ΘΕΡΜΙΚΗ ΚΑΜΕΡΑ' },
    { kind: 'option', key: 'AX', en: 'RADAR', gr: 'ΡΑΝΤΑΡ' },
    { kind: 'option', key: 'AY', en: 'REMOTE SEARCH LIGHT', gr: 'ΠΡΟΒΟΛΕΑΣ' },
    { kind: 'section', key: 'AZ', en: 'DECK & COCKPIT', gr: 'ΝΤΕΚ :' },
    { kind: 'option', key: 'BA', en: 'T-TOP', gr: 'ΣΚΙΑΔΙΟ' },
    { kind: 'option', key: 'BB', en: 'UPGRADE TO SHOXS SEATS', gr: 'ΑΝΑΒΑΘΜΙΣΗ ΣΕ ΚΑΘΙΣΜΑΤΑ SHOX' },
    { kind: 'option', key: 'BC', en: '2ND ROW SEATS', gr: 'ΔΕΥΤΕΡΗ ΣΕΙΡΑ ΚΑΘΙΣΜΑΤΩΝ' },
    { kind: 'option', key: 'BD', en: 'BACK TO BACK WITH FRIDGE', gr: 'ΚΑΝΑΠΕΣ ΜΠΑΚ ΤΟΥ ΜΠΑΚ ΜΕ ΨΥΓΕΙΟ' },
    { kind: 'option', key: 'BE', en: 'CABIN FRIDGE', gr: 'ΨΥΓΕΙΟ ΚΑΜΠΙΝΑΣ' },
    { kind: 'option', key: 'BF', en: 'WET BAR', gr: 'WET BAR' },
    { kind: 'option', key: 'BG', en: '2ND FRIDGE WET BAR', gr: 'ΔΕΥΤΕΡΟ ΨΥΓΕΙΟ ΓΙΑ WET BAR' },
    { kind: 'option', key: 'BH', en: 'ELECTRIC TABLE', gr: 'ΗΛΕΚΤΡΙΚΟ ΤΡΑΠΕΖΙ' },
    { kind: 'option', key: 'BI', en: 'TABLE', gr: 'ΑΠΟΣΠΟΜΕΝΟ ΤΡΑΠΕΖΙ' },
    { kind: 'option', key: 'BJ', en: 'SUN TENT AFT', gr: 'ΑΝΤΗΛΙΑΚΗ ΤΕΝΤΑ ΠΡΥΜΝΗΣ' },
    { kind: 'option', key: 'BK', en: 'SUN TENT BOW', gr: 'ΑΝΤΗΛΙΑΚΗ ΤΕΝΤΑ ΠΛΩΡΗΣ' },
    { kind: 'option', key: 'BL', en: 'T-TOP SIDE TENTS', gr: 'ΠΛΑΪΝΕΣ ΤΕΝΤΕΣ ΣΚΙΑΔΙΟΥ' },
    { kind: 'option', key: 'BM', en: 'AFT SIDE TENTS', gr: 'ΠΛΑΪΝΕΣ ΤΕΝΤΕΣ ΠΡΥΜΝΗΣ' },
    { kind: 'option', key: 'BN', en: 'SUN TENT CLASSIC', gr: 'ΚΛΑΣΙΚΗ ΤΕΝΤΑ ΠΤΥΣΣΟΜΕΝΗ' },
    { kind: 'option', key: 'BO', en: 'BOW TOWING EYES', gr: 'ΚΡΙΚΟΙ ΡΥΜΟΥΛΚΗΣΗΣ ΠΛΩΡΗΣ' },
    { kind: 'option', key: 'BP', en: 'SKI POLE', gr: 'ΙΣΤΟΣ ΣΚΙ' },
    { kind: 'option', key: 'BQ', en: 'CARBON FLAG HOLDER', gr: 'ΚΑΡΜΠΟΝ ΙΣΤΟΣ ΓΙΑ ΣΗΜΑΙΑ' },
    { kind: 'option', key: 'BR', en: 'CABIN IN AFT LOCKER', gr: 'ΚΑΜΠΙΝΑ ΣΤΟ ΠΡΥΜΝΙΟ ΤΑΜΠΟΥΚΙ' },
    { kind: 'option', key: 'BS', en: 'CABIN IN BOW LOCKER', gr: 'ΚΑΜΠΙΝΑ ΣΤΟ ΠΛΩΡΙΟ ΤΑΜΠΟΥΚΙ' },
    { kind: 'option', key: 'BT', en: 'CARBON SHOWER', gr: 'ΝΤΟΥΖ ΚΑΡΜΠΟΝ' },
    { kind: 'section', key: 'BU', en: 'ELECTRIC EQUIPMENT', gr: 'ΗΛΕΚΤΡΟΛΟΓΙΚΑ:' },
    { kind: 'option', key: 'BV', en: 'UNDERWATER', gr: 'ΥΠΟΒΡΥΧΙΑ ΦΩΤΑ' },
    { kind: 'option', key: 'BW', en: 'SHOREPOWER', gr: 'ΠΡΙΖΑ ΞΗΡΑΣ' },
    { kind: 'option', key: 'BX', en: 'BOW THRUSTER', gr: 'BOW THRUSTER' },
    { kind: 'option', key: 'BY', en: 'SOLAR PANEL', gr: 'ΗΛΙΑΚΟ ΠΑΝΕΛ' },
    { kind: 'option', key: 'BZ', en: 'LED BAR', gr: 'LED ΜΠΑΡΑ' },
    { kind: 'option', key: 'CA', en: 'PORTABLE FRIDGE', gr: 'ΦΟΡΗΤΟ ΨΥΓΕΙΟ' },
    { kind: 'option', key: 'CB', en: 'TOILET', gr: 'ΤΟΥΑΛΕΤΑ' },
    { kind: 'option', key: 'CC', en: 'ELECTRIC AFT HATCH', gr: 'ΗΛΕΚΤΡΙΚΟ ΤΑΜΠΟΥΚΙ ΠΡΥΜΝΗΣ' },
    { kind: 'option', key: 'CD', en: 'WINDLASS', gr: 'ΕΡΓΑΤΗΣ ΠΛΩΡΗΣ' },
    { kind: 'option', key: 'CE', en: 'TRIM TABS', gr: 'TRIM TABS' },
    { kind: 'option', key: 'CF', en: 'WASH DOWN', gr: 'WASH DOWN' },
    { kind: 'option', key: 'CG', en: 'COFFE MAKER', gr: 'ΚΑΦΕΤΙΕΡΑ' },
    { kind: 'option', key: 'CH', en: 'A/C', gr: 'ΚΛΙΜΑΤΙΣΤΙΚΟ' },
    { kind: 'option', key: 'CI', en: 'INVERTER', gr: 'INVERTER' },
    { kind: 'option', key: 'CJ', en: 'GENERATOR', gr: 'ΓΕΝΝΗΤΡΙΑ' },
    { kind: 'option', key: 'CK', en: 'WATER HEATER', gr: 'ΘΕΡΜΟΣΙΦΩΝΑΣ' },
    { kind: 'option', key: 'CL', en: 'AFT WINDLASS', gr: 'ΕΡΓΑΤΗΣ ΣΤΗ ΠΡΥΜΝΗ' },
    { kind: 'option', key: 'CM', en: 'AFT ANCHOR', gr: 'ΑΓΚΥΡΑ ΧΕΙΡΟΣ' },
    { kind: 'section', key: 'CN', en: 'ACCESSORIES', gr: 'ΑΞΕΣΟΥΑΡ:' },
    { kind: 'option', key: 'CO', en: 'ANTIFOULING', gr: 'ΜΟΥΡΑΒΙΕΣ' },
    { kind: 'option', key: 'CP', en: 'TRAILER', gr: 'ΤΡΕΪΛΕΡ' },
    { kind: 'option', key: 'CQ', en: 'PARKING COVER', gr: 'ΚΑΛΥΜΜΑ ΠΑΡΚΙΝΓΚ' },
    { kind: 'option', key: 'CR', en: 'CONSOLE COVER', gr: 'ΚΑΛΥΜΜΑ ΚΟΝΣΟΛΑΣ' },
    { kind: 'option', key: 'CS', en: 'SEATS COVER', gr: 'ΚΑΛΥΜΜΑ ΚΑΘIΣΜΑΤΩΝ' },
    { kind: 'option', key: 'CT', en: 'TOWING ROPES', gr: 'ΣΧΟΙΝΙΑ ΡΥΜΟΥΛΚΙΣΗΣ' },
    { kind: 'option', key: 'CU', en: 'SHRINK WRAP', gr: 'ΘΕΡΜΟΣΥΣΤΕΛΛΟΜΕΝΟ' },
    { kind: 'section', key: 'CV', en: 'ADITIONAL REQUESTS:', gr: '' },
    { kind: 'text', key: 'CW', en: 'AR1', gr: '' },
    { kind: 'text', key: 'CX', en: 'AR2', gr: '' },
    { kind: 'text', key: 'CY', en: 'AR3', gr: '' },
    { kind: 'text', key: 'CZ', en: 'AR4', gr: '' },
    { kind: 'text', key: 'DA', en: 'AR5', gr: '' },
    { kind: 'text', key: 'DB', en: 'AR6', gr: '' },
    { kind: 'text', key: 'DC', en: 'AR7', gr: '' },
    { kind: 'text', key: 'DD', en: 'AR8', gr: '' },
    { kind: 'text', key: 'DE', en: 'AR9', gr: '' },
    { kind: 'text', key: 'DF', en: 'AR10', gr: '' },
];
/** the rows that take a value (not the headings) */
export const ORDER_FILE_FIELDS = ORDER_FILE_TEMPLATE.filter((r) => r.kind === 'text' || r.kind === 'option');
const BY_KEY = new Map(ORDER_FILE_TEMPLATE.map((r) => [r.key, r]));
/** a template row by its Order Sheet column */
export const orderFileRow = (key) => BY_KEY.get(key);
/** a column's name as the order form shows it: its English wording, without a trailing colon */
export const orderFileLabel = (key) => (BY_KEY.get(key)?.en ?? key).replace(/[:\s]+$/, '');
/** what an option row holds once ticked */
export const ORDER_FILE_TICK = '+';
/** whether a cell says the boat has it: anything but blank, a dash, "no" or a zero */
export function orderValueOn(v) {
    const s = String(v ?? '').trim();
    return s !== '' && !/^(-+|no|όχι|οχι|0|n\/?a|none)$/i.test(s);
}
/** the file name an order file is kept under: "<SAP> - <NAME>.xlsx", inside the R2 key's allowed characters */
export function orderFileName(sap, name) {
    const clean = (s) => s.replace(/[^A-Za-z0-9 _.()-]+/g, ' ').replace(/\.{2,}/g, '.').replace(/\s+/g, ' ').trim();
    const base = [clean(sap), clean(name)].filter(Boolean).join(' - ') || 'order';
    return `${base}.xlsx`;
}
/** the folder name for a season, matching the local convention: "26-27" → "General 2026-2027". */
export function seasonFolderLabel(id) {
    const [a, b] = (id || '').split('-');
    const sa = parseInt(a ?? '', 10);
    const sb = parseInt(b ?? '', 10);
    if (Number.isNaN(sa) || Number.isNaN(sb))
        return id ? `General ${id}` : 'General';
    return `General ${2000 + sa}-${2000 + sb}`;
}
/** where a boat's order file and its BOM are kept in Info / Files: the season's folder, then the model's */
export const orderListFolder = (season, model) => `order-lists/${seasonFolderLabel(season)}/${model}/`;
/** the BOM workbook that goes beside an order file */
export const orderBomName = (fileName) => fileName.replace(/\.xlsx$/, ' - BOM.xlsx');
//# sourceMappingURL=orderFile.js.map